import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Command, Condition, QuestionCard } from '@empathy/survey/base';
import { IMediaForm } from '@empathy/survey-core';

import { IQuestionCardForm } from './question-form-group.interface';
import { ConditionForm } from '../conditions/condition-form.model';

export class QuestionCardForm {
  form = new FormGroup<IQuestionCardForm>({
    id: new FormControl<string>(''),
    text: new FormControl<string>(''),
    stimulus: new FormGroup<IMediaForm>({
      mediaId: new FormControl<string>(''),
      name: new FormControl<string>(''),
      type: new FormControl<string>('')
    }),
    pinnedPositionInd: new FormControl<boolean>(false),
    visibleWhen: new FormArray([])
  });

  constructor(question?: QuestionCard) {
    if (!question) {
      this.form.get('id').setValue('card_1');
      return;
    }

    this.form.patchValue(question);
    this.patchVisibleWhen(question.visibleWhen);
  }

  private patchVisibleWhen(visibleWhen: (Condition | Command)[]): void {
    if (!visibleWhen || visibleWhen.length === 0) {
      return;
    }

    visibleWhen.forEach((condition) => {
      if (typeof condition === 'object') {
        (this.form.get('visibleWhen') as FormArray).push(new ConditionForm(condition as Condition).form);
      } else {
        (this.form.get('visibleWhen') as FormArray).push(new FormControl(condition as Command));
      }
    });
  }
}
